// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Precio_container__qaRlO {
    position: relative;
    background: var(--gradient-main);
    margin-bottom: 80px;
    padding-top: 9%;
    padding-bottom: 8%;
}

.Precio_container__qaRlO svg:first-of-type {
    position: absolute;
    top: -1px;
}

.Precio_container__qaRlO svg:last-of-type {
    position: absolute;
    bottom: -1px;
}

.Precio_information-details__wEnVK h2 {
    text-align: center;
    font-size: 46px;
}

.Precio_info-text-price-cont__dqxNL {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 80px;
}

.Precio_info-text-price-cont__dqxNL > p {
    padding: 0 3%;
    align-self: center;
    justify-self: center;
    font-size: 24px;
}

.Precio_info-text-price-cont__dqxNL > p a {
    text-decoration: underline;
    cursor: pointer;
}

.Precio_price-detail__BqsWe {
    width: 50%;
    height: max-content;
    justify-self: center;
    align-self: center;
    background-color: white;
    border-radius: 10px;
    padding: 30px 20px;
    box-shadow: 0 8px 24px rgba(28, 35, 43, 0.25);
}

.Precio_price-detail__BqsWe div {
    text-align: center;
}

.Precio_price-detail__BqsWe div p {
    font-size: 20px;
}

.Precio_price-detail__BqsWe div h3 {
    font-size: 65px;
    color: var(--blue-main);
}

.Precio_price-detail__BqsWe div h3 span {
    font-size: 35px;
    margin-left: -10px;
}

.Precio_price-detail__BqsWe div h4 {
    font-size: 22px;
    margin-top: -10px;
    margin-bottom: 20px;
}


@media screen and (max-width: 1536px) {
    .Precio_information-details__wEnVK h2 {
        font-size: 40px;
    }

    .Precio_info-text-price-cont__dqxNL > p {
        font-size: 22px;
    }

    .Precio_price-detail__BqsWe {
        width: 65%;
    }

    .Precio_price-detail__BqsWe > p {
        font-size: 20px;
    }
}

@media screen and (max-width: 1200px) {
    .Precio_information-details__wEnVK h2 {
        font-size: 36px;
    }

    .Precio_info-text-price-cont__dqxNL > p {
        font-size: 20px;
    }

    .Precio_price-detail__BqsWe {
        width: 70%;
    }

    .Precio_price-detail__BqsWe div p {
        font-size: 18px;
    }

    .Precio_price-detail__BqsWe div h3 {
        font-size: 58px;
    }

    .Precio_price-detail__BqsWe div h3 span {
        font-size: 30px;
    }

    .Precio_price-detail__BqsWe div h4 {
        font-size: 20px;
    }
}

@media screen and (max-width: 992px) {
    .Precio_information-details__wEnVK h2 {
        font-size: 34px;
    }

    .Precio_info-text-price-cont__dqxNL {
        margin-top: 50px;
        grid-template-columns: none;
        grid-row-gap: 30px;
    }

    .Precio_info-text-price-cont__dqxNL > p {
        text-align: center;
        font-size: 20px;
    }

    .Precio_price-detail__BqsWe {
        width: 40%;
    }
}

@media screen and (max-width: 768px) {
    .Precio_info-text-price-cont__dqxNL > p {
        font-size: 18px;
    }

    .Precio_price-detail__BqsWe {
        width: 48%;
    }

    .Precio_price-detail__BqsWe div p {
        font-size: 16px;
    }

    .Precio_price-detail__BqsWe div h3 {
        font-size: 50px;
        margin-top: 10px;
    }

    .Precio_price-detail__BqsWe div h3 span {
        font-size: 26px;
        margin-left: -5px;
    }

    .Precio_price-detail__BqsWe div h4 {
        font-size: 18px;
        margin-bottom: 15px;
    }

    .Precio_price-detail__BqsWe > p {
        font-size: 18px;
    }
}

@media screen and (max-width: 576px) {
    .Precio_information-details__wEnVK h2 {
        font-size: 30px;
    }

    .Precio_info-text-price-cont__dqxNL > p {
        font-size: 16px;
    }

    .Precio_price-detail__BqsWe {
        width: 60%;
    }

    .Precio_price-detail__BqsWe div h3 {
        font-size: 45px;
    }

    .Precio_price-detail__BqsWe div h3 span {
        font-size: 22px;
    }

    .Precio_price-detail__BqsWe > p {
        font-size: 16px;
    }
}

@media screen and (max-width: 480px) {
    .Precio_price-detail__BqsWe {
        width: 82%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/BodyLanding/Precio/Precio.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,2BAA2B;QAC3B,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":[".container {\n    position: relative;\n    background: var(--gradient-main);\n    margin-bottom: 80px;\n    padding-top: 9%;\n    padding-bottom: 8%;\n}\n\n.container svg:first-of-type {\n    position: absolute;\n    top: -1px;\n}\n\n.container svg:last-of-type {\n    position: absolute;\n    bottom: -1px;\n}\n\n.information-details h2 {\n    text-align: center;\n    font-size: 46px;\n}\n\n.info-text-price-cont {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    margin-top: 80px;\n}\n\n.info-text-price-cont > p {\n    padding: 0 3%;\n    align-self: center;\n    justify-self: center;\n    font-size: 24px;\n}\n\n.info-text-price-cont > p a {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.price-detail {\n    width: 50%;\n    height: max-content;\n    justify-self: center;\n    align-self: center;\n    background-color: white;\n    border-radius: 10px;\n    padding: 30px 20px;\n    box-shadow: 0 8px 24px rgba(28, 35, 43, 0.25);\n}\n\n.price-detail div {\n    text-align: center;\n}\n\n.price-detail div p {\n    font-size: 20px;\n}\n\n.price-detail div h3 {\n    font-size: 65px;\n    color: var(--blue-main);\n}\n\n.price-detail div h3 span {\n    font-size: 35px;\n    margin-left: -10px;\n}\n\n.price-detail div h4 {\n    font-size: 22px;\n    margin-top: -10px;\n    margin-bottom: 20px;\n}\n\n\n@media screen and (max-width: 1536px) {\n    .information-details h2 {\n        font-size: 40px;\n    }\n\n    .info-text-price-cont > p {\n        font-size: 22px;\n    }\n\n    .price-detail {\n        width: 65%;\n    }\n\n    .price-detail > p {\n        font-size: 20px;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .information-details h2 {\n        font-size: 36px;\n    }\n\n    .info-text-price-cont > p {\n        font-size: 20px;\n    }\n\n    .price-detail {\n        width: 70%;\n    }\n\n    .price-detail div p {\n        font-size: 18px;\n    }\n\n    .price-detail div h3 {\n        font-size: 58px;\n    }\n\n    .price-detail div h3 span {\n        font-size: 30px;\n    }\n\n    .price-detail div h4 {\n        font-size: 20px;\n    }\n}\n\n@media screen and (max-width: 992px) {\n    .information-details h2 {\n        font-size: 34px;\n    }\n\n    .info-text-price-cont {\n        margin-top: 50px;\n        grid-template-columns: none;\n        grid-row-gap: 30px;\n    }\n\n    .info-text-price-cont > p {\n        text-align: center;\n        font-size: 20px;\n    }\n\n    .price-detail {\n        width: 40%;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .info-text-price-cont > p {\n        font-size: 18px;\n    }\n\n    .price-detail {\n        width: 48%;\n    }\n\n    .price-detail div p {\n        font-size: 16px;\n    }\n\n    .price-detail div h3 {\n        font-size: 50px;\n        margin-top: 10px;\n    }\n\n    .price-detail div h3 span {\n        font-size: 26px;\n        margin-left: -5px;\n    }\n\n    .price-detail div h4 {\n        font-size: 18px;\n        margin-bottom: 15px;\n    }\n\n    .price-detail > p {\n        font-size: 18px;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .information-details h2 {\n        font-size: 30px;\n    }\n\n    .info-text-price-cont > p {\n        font-size: 16px;\n    }\n\n    .price-detail {\n        width: 60%;\n    }\n\n    .price-detail div h3 {\n        font-size: 45px;\n    }\n\n    .price-detail div h3 span {\n        font-size: 22px;\n    }\n\n    .price-detail > p {\n        font-size: 16px;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .price-detail {\n        width: 82%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Precio_container__qaRlO`,
	"information-details": `Precio_information-details__wEnVK`,
	"info-text-price-cont": `Precio_info-text-price-cont__dqxNL`,
	"price-detail": `Precio_price-detail__BqsWe`
};
export default ___CSS_LOADER_EXPORT___;
